// AgencyInvoicesShowTabs' read (finance-real, the user 2026-10-22): each status tab's count, client and team invoices
// both, from the Invoices tab's own read.
import type { UseQueryResult } from "@tanstack/react-query";
import { useAgencyInvoiceList } from "../../hooks/useTeamInvoices";
import type { AgencyInvoiceListResponse } from "../../types";

export function useAgencyInvoicesShowTabs(): UseQueryResult<AgencyInvoiceListResponse> {
  return useAgencyInvoiceList();
}
